module.exports = __webpack_public_path__ + "img/three2Red.ce3bcfbd.jpg";